/* eslint-disable */
'use strict';

import _ from 'lodash';
var tinyColor = require("tinycolor2");

import Wix from 'Wix';

let wixService = function () {
  let self = this;
  let wix = Wix;
  let url;
  wix.Utils = wix.Utils || {};

  wix.getMyLocale = function (defaultLocale) {
    try {
      let locale = wix.Utils.getLocale() || defaultLocale;
      locale = locale.toLowerCase().replace(/[^a-zA-Z]+/g, '');
      return locale.length === 2 ? locale : defaultLocale;
    } catch (e) {
      return defaultLocale;
    }
  }

  wix.deepClone = function (obj) {
    try {
      return JSON.parse(JSON.stringify(obj));
    } catch (e) {
      return obj;
    }
  }

  wix.getParamFromURL = function (name) {
    var val;
    var url =  window.location.search;
    try {
      val = new URLSearchParams(url).get(name);
    } catch (err) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(url);

      val = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    return val;
  };

  wix.stripTags = function (input, allowed) {
    // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
    allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');
    var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
    var commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;

    return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
      return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
    });
  };

  wix.myNavigateTo = function (link) {
    link = JSON.parse(link.replace(/\~#~/g, '"'));
    return wix.navigateTo(link);
  };

  wix.Utils.getInstance = function () {
   if (typeof window !== 'undefined'){
      url = window.location.search;
      let instanceRegexp = /.*instance=([\[\]a-zA-Z0-9\.\-_]*?)(&|$|#).*/g;
      let instance = instanceRegexp.exec(url);
      return (instance && instance[1]) ? instance[1] : undefined;
   }else return "";
  };

   wix.isPremium = function(){
    return  wix.Utils.getInstanceValue('vendorProductId') !== null;
  };

   wix.openPremiumLink = function(appDefinitionId){
       let {metaSiteId} = wix.getAppIds();
       let URL = `https://www.wix.com/store/plans?siteGuid=${metaSiteId}`;
       window.open(URL,'_new');
   };
  wix.isMobile = function () {
    return (wix.Utils.getDeviceType() === "mobile");
  };

  wix.isDesktop = function () {
    return (wix.Utils.getDeviceType() === 'desktop');
  };

  wix.isEditorMode = function () {
    return (wix.Utils.getViewMode() === "editor");
  };

  wix.isSiteMode = function () {
    return (wix.Utils.getViewMode() === "site");
  };

  wix.isPreviewMode = function () {
    return (wix.Utils.getViewMode() === "preview");
  };

  wix.isIOS = function () {
    let userAgent = navigator.userAgent.toLowerCase(),
      isIPhone = (userAgent.indexOf("iphone") >= 0),
      isIPod = (userAgent.indexOf("ipod") >= 0),
      isIPad = (userAgent.indexOf("ipad") >= 0);

    return (isIPhone || isIPod || isIPad);
  };

  wix.isIPhone = function () {
    let userAgent = navigator.userAgent.toLowerCase(),
      isIPhone = (userAgent.indexOf("iphone") >= 0);

    return (isIPhone);
  };

  wix.isIpad = function () {
    let userAgent = navigator.userAgent.toLowerCase(),
      isIPad = (userAgent.indexOf("ipad") >= 0);

    return (isIPad);
  };

  wix.getAppIds = function () {
    const instanceId = Wix.Utils.getInstanceId();
    const biToken = Wix.Utils.getInstanceValue('biToken') || '';
    const metaSiteId = Wix.Utils.getInstanceValue('metaSiteId') || '';
    return { instanceId, metaSiteId, biToken };
  };

  wix.replaceAllSpaces = function (elem) {
    document.getElementsByClassName(elem).each(function () {
      //var self = angular.element(this);
      //self.html(self.html().replace(/&nbsp;/gi, ' '));
    });
  };

  wix.getCookieKey = function (keyName) {
    const compId = wix.Utils.getOrigCompId() || wix.Utils.getCompId();
    return [keyName, wix.Utils.getInstanceId(), compId].join('_');
  }

  wix.getObjValue = function(obj) {
    return _.isObject(obj) && obj.hasOwnProperty('value') ? obj.value : obj;
  }

  wix.getFontObjValue = function(objFont) {
    try {
      var italic = (objFont.style.italic) ? 'italic ' : 'normal ';
      var bold = (objFont.style.bold) ? 'bold ' : 'normal ';
      // var underline = (objFont.style.underline) ? 'underline' : 'normal';
      var size = objFont.size + 'px/1.2em ';
      var family = objFont.family;

      objFont = italic + bold + size + family ;
      return  objFont;
    }catch (err){
      return  objFont;
    }
  }
  wix.getFontTextDecoration = function(styleParams, componentName) {
    if (styleParams && styleParams.fonts && styleParams.fonts[componentName]) {
      try {
        let objFont  = styleParams.fonts[componentName]
        return  (objFont.style.underline) ? 'underline' : 'normal';
      } catch (e) {
        return 'normal';
      }
    }
    return 'normal';
  }

  wix.getColorByreference = function(color) {
    return wix.getObjValue(Wix.Styles.getColorByreference(color));
  }

  wix.getColorValueByComponentName = function(styleParams, componentName) {
    if (styleParams) {
      try {
        return  wix.getObjValue(styleParams.colors[componentName]);
      } catch (e) {
        return '';
      }
    }
  }

  wix.getStyleFontByReference = function(font, isRCV) {
    return (isRCV) ? Wix.Styles.getStyleFontByReference(font) :  wix.getObjValue(Wix.Styles.getStyleFontByReference(font), true);
  }

  wix.getFontValueByComponentName = function(styleParams, componentName, isRCV) {
    if (styleParams && styleParams.fonts && styleParams.fonts[componentName]) {
      try {
        return (isRCV) ? styleParams.fonts[componentName] : wix.getFontObjValue(styleParams.fonts[componentName]);
      } catch (e) {
        return '';
      }
    }
  }

  wix.getTinycolor = function (color) {
    try {
      return tinyColor(color);
    }catch (e) {
      return color;
    }
  }

  wix.setWixPublicData = function (key, data) {
    // Default setting for the key field
    wix.Data.Public.set(
      key, data, {scope: 'COMPONENT'},
      function (d) {

      },
      function (f) {

      }
    );
  };

  wix.removeWixPublicData = function (key) {
    wix.Data.Public.remove(
      key, {scope: 'COMPONENT'},
      function (d) {
      },
      function (f) {

      }
    );
  };

  wix.getWixPublicData = function (key) {
    return new Promise((resolve, reject) => {
      window.Wix.Data.Public.get(
        key,
        {
          scope: 'COMPONENT',
        },
        (d) => {
          resolve(d);
        },
        (f) => {
          reject(f);
        },
      );
    });
  };

  return wix;
};
export default wixService();
